import { createContext } from 'react'
import { SnackbarHandler } from 'types'

export const SnackbarContext = createContext<
  SnackbarHandler | undefined
>(undefined)
